import { render, staticRenderFns } from "./SubordiNate.vue?vue&type=template&id=7825777e&scoped=true"
import script from "./SubordiNate.vue?vue&type=script&lang=js"
export * from "./SubordiNate.vue?vue&type=script&lang=js"
import style0 from "./SubordiNate.vue?vue&type=style&index=0&id=7825777e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7825777e",
  null
  
)

export default component.exports